import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';

const Pay = () => {
    return (
        <Box style={{ display: 'flex', justifyContent: 'center' }}>
            <Typography variant="h5">
                Payment system is coming soon.
            </Typography>
        </Box>
    );
};

export default Pay;